<template>
  <v-container fluid>
    <div
      v-if="!dataLoading"
      class="d-flex flex-column employee-card-path-to-readiness"
    >
      <EmployeePageHeader
        v-if="true"
        :key="
          employeeData && employeeData.id
            ? employeeData.id +
              '-' +
              (employeeData.primary_positions
                ? employeeData.primary_positions.length
                : 0) +
              '-' +
              currentEmployeeStatus
            : 'default'
        "
        :status="currentEmployeeStatus"
        :name="employeeFullName"
        :avatar="employeeData?.avatar || ''"
        :title="employeeData?.title || ''"
        :archived="isArchived"
        :tracking="isTracking"
        :readiness="employeeData?.current_readiness || 0"
        :last_month_readiness="lastMonthReadiness"
        :breadcrumbs="breadcrumbsList"
        :employeeId="employeeData?.id"
        :employeeData="employeeData"
        @employeeUpdated="handleEmployeeUpdate"
        @employeeStatusChanged="handleEmployeeStatusChanged"
        @employeeDeleted="handleEmployeeDeleted"
      />

      <div v-if="!dataLoading" class="custom-path path-to-readiness-scrollable">
        <div v-if="dataSource.length === 0 && employeeData">
          <NoRecordFound
            :title="''"
            :subtitle="''"
            :showSpecificMessage="title"
            message=""
            class="no-record-found"
            :shouldShowAddAction="true"
            :noBorder="true"
            :showActiveCounter="false"
            :showClearAction="false"
            :btnTitle="btnTitle"
            :addPrefix="false"
            :description="description"
            :plusIcon="false"
            @onAction="handleButtonClick"
          />
        </div>
        <PathToReadinessTreeList
          v-else
          ref="PathToReadinessTreeList"
          :key="treeListKey"
          :dataSource="dataSource"
          :topLevel="topLevel"
          :removeBorder="removeBorder"
          :dropdownItems="dropdownItems"
          @optionClick="onOptionClick"
          @treeExpandRole="onTreeExpandRole"
          :showRespBadge="true"
          :showAvailableCoaches="true"
          @loadData="reloadDataAfterChanges()"
          @importanceChanged="onImportanceChanged"
          :loading="loading.initial"
          :treeMode="true"
          :expandedKeys="expandedKeys"
          @onExpansionStateChange="handleExpansionStateChange"
          @loadDataAfterBadgeOperation="reloadDataAfterBadgeOperation()"
          @chatter-click="openChatterDrawer($event.data)"
          :read_only="read_only"
        />
        <ExPagination
          v-if="dataSource.length > 0 && pagination.total > pagination.perPage"
          :pagination="pagination"
          @onRequest="handlePaginationRequest"
        />
      </div>
      <EmployeeModal
        :dialog="isForceBadge"
        :empName="
          employeeData
            ? `${employeeData.first_name} ${employeeData.last_name}`
            : ''
        "
        :employee="employeeDataWithBadges || employeeInfo"
        :responsibility="currentResponsibility"
        label="Responsibility"
        :name="currentResponsibility && currentResponsibility.name"
        :empForceBadgeClass="true"
        :hideEmployeePicker="true"
        :value="[1]"
        @back="onEmployeeModalBack"
        @onAction="onClickForceBadge"
        :showStep="2"
        @removeBadge="showRemoveBadge"
      />
      <EvalResponsibilityModal
        v-if="isInspectResModal"
        :dialog="isInspectResModal"
        :badges="badges"
        :checkpointsData="checkpointsData"
        :checkpointCounts="currentCheckpointCounts"
        :evalModalHeaderState="evalModalHeaderState"
        :evalModalEmpState="evalModalEmpState"
        @closeModal="isInspectResModal = false"
        :currentResponsibilityId="
          currentResponsibility && currentResponsibility.id
        "
        :assignmentData="false"
        @grantBadge="grantOrForceBadge"
        @reloadData="reloadCheckpointsData"
        @removeBadge="processRemoveBadgeFromEvalModal"
        @upgradeBadge="upgradeBadge"
        @reloadBadgeHolderItems="reloadDataAfterChanges"
        @showAwardBadge="showAwardBadge"
      />
      <ActivateEmployee
        :show="activateEmployee"
        :employee="currenntEmployee"
        @onClose="onCloseModal"
        @onActiveEmployee="handleActivateEmployee"
      ></ActivateEmployee>
      <ReActivateEmployee
        :show="reActivateEmployee"
        :employee="currenntEmployee"
        @onClose="onCloseModal"
        @onActiveEmployee="reactivateEmployee"
      ></ReActivateEmployee>

      <ExEmployeePrimaryAssignmentWizard
        label="Position"
        v-model="assignPosition"
        :items="primaryPositions.availablePositions"
        :currentEmployee="employeeData"
        @onAssignPosition="onAssignPositionToEmployee"
        :type="'scrollPositionPicker'"
        :isLoadingMore="primaryPositions.isLoadingMore"
        :hasMoreData="primaryPositions.hasMoreData"
        @load-more="loadMorePrimaryPositions"
        @search="searchPrimaryPositions"
        :errorMessage="errorMessage"
        :isAssigning="loading.employeeAssignment"
      />
      <RetireResponsibilityCatelog
        v-model="showRetireResponsibilityDialog"
        :responsibility="
          currentResponsibility && currentResponsibility.name
            ? currentResponsibility.name
            : ''
        "
        @onSave="retireResponsibility"
      />
      <BadgeConfirmationDialog
        :isVisible="showBadgeConfirmationDialog"
        :badgeData="badgeData"
        :badgeType="
          badgeData &&
          badgeData.payload &&
          badgeData.payload.issued_method == 'given'
            ? 'Give'
            : 'Award'
        "
        :responsibilityName="
          currentResponsibility && currentResponsibility.name
            ? currentResponsibility.name
            : ''
        "
        :employee="{
          name: employeeData
            ? `${employeeData.first_name} ${employeeData.last_name}`
            : '',
          avatar: employeeData && employeeData.photoUrl,
        }"
        :level="
          getBadgeLevel(
            badgeData && badgeData.payload ? badgeData.payload.level : null
          )
        "
        @close="showBadgeConfirmationDialog = false"
        :currentEmployee="$store.getters['employeeStore/currentEmployee']"
        @onClick="onClick"
      />
      <AwardBadgeDialog
        :employee="{
          name:
            evalModalEmpState && evalModalEmpState.firstName
              ? evalModalEmpState.firstName
              : '',
          avatar: evalModalEmpState && evalModalEmpState.photoUrl,
        }"
        :level="awardBadgeLevel"
        :isVisible="showAwardBadgeModal"
        @skip="showAwardBadgeModal = false"
        @close="showAwardBadgeModal = false"
        @activate="awardBadge"
        :currentEmployee="$store.getters['employeeStore/currentEmployee']"
        :responsibilityName="(currentSelectRes && currentSelectRes.name) || ''"
      />
      <ChatterDrawer
        :drawer="showChatterDrawer"
        :type="
          chatterType === 'badge'
            ? 'Badge'
            : chatterType === 'responsibility'
            ? 'Responsibility'
            : 'Badge'
        "
        :typeValue="chatterTypeValue || ''"
        :listData="selectedBadgeChatter"
        @closeDrawer="closeChatterDrawer"
        :iconName="chatterIconName || 'org_icon_responsibility'"
        :chatterList="chatterData"
        :totalCheckpointChatter="totalChatter"
        @requestMoreCheckpointsChatter="loadMoreChatter"
      />
      <RemoveBadgeDialog
        v-model="showRemoveBadgeDialog"
        :badgeName="selectedBadgeForRemoval?.badgeName || ''"
        :responsibilityName="selectedBadgeForRemoval?.responsibilityName || ''"
        :employeeName="employeeFullName || ''"
        @remove="handleConfirmRemoveBadge"
        @close="handleCloseRemoveBadgeDialog"
      />
    </div>
  </v-container>
</template>
<script>
import AwardBadgeDialog from "@components/AwardBadgeDialog/AwardBadgeDialog.vue";
import NoRecordFound from "@components/NoRecordFound/NoRecordFound.vue";
import PathToReadinessTreeList from "@components/DataTable/PathToReadinessTreeList.vue";
import ExPagination from "@components/DataTable/ExPagination.vue";
import dropdownMixin from "@components/DropDownMenu/dropdownMixin";
import EmployeeModal from "@components/EmployeeModal/EmployeeModal.vue";
import EvalResponsibilityModal from "@components/EvalResponsibilityModal/EvalResponsibilityModal.vue";
import RetireResponsibilityCatelog from "@components/RetireResponsibilityCatelog/RetireResponsibilityCatelog.vue";
import EmployeePageHeader from "@components/common/EmployeePageHeader.vue";
import {
  getListActiveCheckpointsEval,
  getListActiveCheckpointsEvalV2,
  createProficiencyBadge,
  activateEmployee,
  reactivateEmployee,
  unArchiveEmployee,
  deleteResponsibilityBadge,
  updateRetireResponsibility,
  getRoleAssignment,
  getListofResponsibility,
  getEmployeeAssignments,
  addPositionAssignment,
  getResponsibilityAssignment,
  getAssignmentEval,
  getEmployeeBadges,
  getListOfPositionsForAssignment,
  getChatterList,
  // getResponsibilityChecklist,
} from "@/api";
import ExEmployeePrimaryAssignmentWizard from "@components/PositionPicker/ExEmployeePrimaryAssignmentWizard.vue";
import ActivateEmployee from "@components/modals/ActiveEmployee.vue";
import ReActivateEmployee from "@components/modals/ReActivateEmployee.vue";
import { usePositionStore } from "@/store/pinia/position";
import { useEmployeeStore } from "@/store/pinia/employee";
import BadgeConfirmationDialog from "@components/BadgeConfirmationDialog/BadgeConfirmationDialog.vue";
import { useReadinessCatalogsStore } from "@/store/pinia/readinessCatalog";
import ChatterDrawer from "@components/Drawer/ChatterDrawer.vue";
import RemoveBadgeDialog from "@components/RemoveBadgeDialog/RemoveBadgeDialog.vue";

export default {
  name: "EmployeePathToReadinessView",
  components: {
    PathToReadinessTreeList,
    EmployeeModal,
    EvalResponsibilityModal,
    NoRecordFound,
    ActivateEmployee,
    ReActivateEmployee,
    ExEmployeePrimaryAssignmentWizard,
    RetireResponsibilityCatelog,
    BadgeConfirmationDialog,
    AwardBadgeDialog,
    ExPagination,
    EmployeePageHeader,
    ChatterDrawer,
    RemoveBadgeDialog,
  },
  props: {
    read_only: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dataSource: [],
      topLevel: "position",
      removeBorder: false,
      currentReadiness: null,
      currentSelectRes: null,
      currentResponsibility: null,
      isForceBadge: false,
      showEmployeeIssueBadge: false,
      isInspectResModal: false,
      allResponsibilities: [],
      checkpointsData: [],
      evalModalEmpState: null,
      evalModalHeaderState: null,
      activateEmployee: false,
      reActivateEmployee: false,
      unArchiveEmployee: false,
      assignPosition: false,
      currenntEmployee: null,
      errorMessage: "",
      positionStore: usePositionStore(),
      employeeStore: useEmployeeStore(),
      responsibilitiesToUseIds: [],
      showAwardBadgeModal: false,
      awardBadgeLevel: null,
      treeListKey: 0,
      badges: [
        {
          badge_id: "Apprentice",
          type: "Given",
        },
        {
          badge_id: "Professional",
          is_force: true,
        },
        {
          badge_id: "Coach",
        },
        {
          badge_id: "Master",
          is_force: false,
        },
      ],
      employeeData: null,
      employeeDataWithBadges: null,
      loading: {
        initial: false,
        readinessBar: false,
        responsibilities: {},
        assignments: false,
        employeeAssignment: false,
        forceBadge: false,
        employeeStatus: false,
        checkpoint: false,
      },
      cachedAccountID: null,
      cachedEmpId: null,
      cachedAuthUser: null,
      showRetireResponsibilityDialog: false,
      showBadgeConfirmationDialog: false,
      badgeData: null,
      dataLoading: false,
      readinessStore: useReadinessCatalogsStore(),
      pagination: {
        limit: 10,
        offset: 0,
        total: 0,
        perPage: 10,
        page: 1,
      },
      // Add expanded row loading states
      expandedRowLoadingStates: {},
      currentCheckpointCounts: {},
      weeklyReadinessData: [],
      primaryPositions: {
        availablePositions: [],
        isLoadingMore: false,
        currentPage: 1,
        totalCount: 0,
        hasMoreData: true,
        currentSearchTerm: "",
      },
      // Store expanded tree state
      expandedKeys: [],
      // Store loaded child data to prevent duplicate API calls during expansion
      loadedChildData: new Map(),
      // Flag to track if initial data load has completed
      isInitialLoadComplete: false,
      // Flag to prevent concurrent API calls
      isLoadingData: false,
      showChatterDrawer: false,
      selectedBadgeChatter: null,
      chatterData: [],
      chatterPage: 1,
      totalChatter: 0,
      chatterLoading: false,
      chatterType: null, // 'badge' or 'responsibility'
      chatterTypeValue: null, // Badge level or responsibility name
      chatterIconName: null,
      showRemoveBadgeDialog: false,
      selectedBadgeForRemoval: null,
    };
  },
  mixins: [dropdownMixin],
  async mounted() {
    this.cachedAccountID = JSON.parse(localStorage.getItem("currentAccountID"));
    this.cachedAuthUser = JSON.parse(localStorage.getItem("user"));

    // Get employeeId from route, ensuring it's valid
    const routeEmpId =
      this.$route?.params?.id || this.$route?.query?.employeeId;

    // Validate employeeId before caching
    if (routeEmpId && routeEmpId !== "undefined" && routeEmpId !== "null") {
      this.cachedEmpId = String(routeEmpId);
    } else {
      // If no valid employeeId in route, wait a bit for route to update
      // This can happen when navigating from employee list
      await this.$nextTick();
      const updatedEmpId =
        this.$route?.params?.id || this.$route?.query?.employeeId;
      if (
        updatedEmpId &&
        updatedEmpId !== "undefined" &&
        updatedEmpId !== "null"
      ) {
        this.cachedEmpId = String(updatedEmpId);
      } else {
        console.error("No valid employeeId found in route on mount");
        this.$router.replace({ name: "NotFound" });
        return;
      }
    }

    this.$loader.show();
    this.dataLoading = true;
    this.$loader.hide();
    const success = await this.initializeData();
    if (!success) {
      this.$router.replace({ name: "NotFound" });
      return;
    }
    this.dataLoading = false;
    this.isInitialLoadComplete = true;
    await this.positionStore.loadPositions();
  },
  watch: {
    currentEmployeeStatus: {
      handler(newStatus, oldStatus) {
        const status = newStatus?.toLowerCase();
        if (status === "terminated" && oldStatus !== "terminated") {
          // Update Path to Readiness in real-time when status changes to terminated
          const employeeData =
            this.employeeStore.currentEmployee ||
            this.$store.getters["employeeStore/currentEmployee"];
          if (employeeData) {
            this.updateEmployeeDataForTermination(employeeData);
          }
        }
      },
      immediate: false,
    },
    // Watch employeeInfo to catch store updates immediately
    employeeInfo: {
      handler(newEmployee, oldEmployee) {
        if (
          newEmployee &&
          newEmployee.id ===
            (this.cachedEmpId ||
              this.$route?.params?.id ||
              this.$route?.query?.employeeId)
        ) {
          const newStatus = (
            newEmployee.current_status ||
            newEmployee.status ||
            ""
          ).toLowerCase();
          const oldStatus = oldEmployee
            ? (
                oldEmployee.current_status ||
                oldEmployee.status ||
                ""
              ).toLowerCase()
            : "";

          if (newStatus === "terminated" && oldStatus !== "terminated") {
            // Update Path to Readiness in real-time when status changes to terminated
            this.updateEmployeeDataForTermination(newEmployee);
          }
        }
      },
      deep: true,
      immediate: false,
    },
    // Watch employeeData status directly for immediate updates
    "employeeData.current_status": {
      handler(newStatus, oldStatus) {
        const normalizedNew = (newStatus || "").toLowerCase();
        const normalizedOld = (oldStatus || "").toLowerCase();
        if (normalizedNew === "terminated" && normalizedOld !== "terminated") {
          // Update Path to Readiness immediately when status changes to terminated
          if (this.employeeData) {
            this.updateEmployeeDataForTermination(this.employeeData);
          }
        }
      },
      immediate: false,
    },
    "employeeData.status": {
      handler(newStatus, oldStatus) {
        const normalizedNew = (newStatus || "").toLowerCase();
        const normalizedOld = (oldStatus || "").toLowerCase();
        if (normalizedNew === "terminated" && normalizedOld !== "terminated") {
          // Update Path to Readiness immediately when status changes to terminated
          if (this.employeeData) {
            this.updateEmployeeDataForTermination(this.employeeData);
          }
        }
      },
      immediate: false,
    },
    "$route.params.id": {
      handler(newId, oldId) {
        // Skip if it's the initial load (mounted() handles that) or if IDs are the same
        if (!oldId || newId === oldId) {
          return;
        }

        if (newId && newId !== oldId) {
          // Force refresh of employee data when route changes
          this.$nextTick(async () => {
            const success = await this.handleRefreshEmployeeData();
            if (!success) {
              this.$router.replace({ name: "NotFound" });
            }
          });
        }
      },
      immediate: false,
    },
    "$route.query.employeeId": {
      handler(newId, oldId) {
        // Handle query param changes
        if (
          newId &&
          newId !== oldId &&
          newId !== "undefined" &&
          newId !== "null" &&
          !this.$route.params.id
        ) {
          // Update cached employeeId
          this.cachedEmpId = String(newId);
          this.$nextTick(async () => {
            const success = await this.handleRefreshEmployeeData();
            if (!success) {
              this.$router.replace({ name: "NotFound" });
            }
          });
        }
      },
      immediate: false,
    },
    // Watch Pinia store for employee updates (same pattern as EmployeeDetail.vue)
    // This ensures employeeData updates reactively when store changes
    piniaCurrentEmployee: {
      handler(newEmployee) {
        if (
          newEmployee &&
          newEmployee.id ===
            (this.cachedEmpId ||
              this.$route?.params?.id ||
              this.$route?.query?.employeeId)
        ) {
          // Get old status before updating
          const oldStatus = (
            this.employeeData?.current_status ||
            this.employeeData?.status ||
            ""
          ).toLowerCase();

          // Sync store updates to local employeeData for immediate reactivity
          // Merge with existing employeeData if it exists, otherwise use newEmployee
          const mergedData = this.employeeData
            ? { ...this.employeeData, ...newEmployee }
            : { ...newEmployee };
          this.$set(this, "employeeData", mergedData);

          // Check if status changed to terminated
          const newStatus = (
            newEmployee.current_status ||
            newEmployee.status ||
            ""
          ).toLowerCase();

          if (newStatus === "terminated" && oldStatus !== "terminated") {
            // Clear Path to Readiness data immediately
            this.clearPathToReadinessData();
          }
        }
      },
      deep: true,
      immediate: false,
    },
  },

  computed: {
    eligiblePositions() {
      if (!this.employeeData) return [];

      let employees = [];
      try {
        const exlAppData = JSON.parse(localStorage.getItem("exlAppData"));
        employees = exlAppData?.employees || [];
      } catch (error) {
        employees = [];
      }

      if (!employees || !Array.isArray(employees)) {
        return [];
      }

      const employee = employees.find((el) => el.id === this.employeeData.id);
      const currentEmployeeData = employee || this.employeeData;
      const allPositions = this.positionStore.positions;
      let allocationSum = 0;

      if (currentEmployeeData.primary_positions?.length > 0) {
        currentEmployeeData.primary_positions.forEach((el) => {
          allocationSum += el.allocation;
        });
      }

      const employeeVacant = currentEmployeeData.availability - allocationSum;
      const allocationsArray = [];

      if (employees && Array.isArray(employees)) {
        employees.forEach((item) => {
          if (item.primary_positions?.length > 0) {
            item.primary_positions.forEach((positionAssignment) => {
              const newEl = {
                id: positionAssignment.position,
                allocation: positionAssignment.allocation,
              };
              const itemExist = allocationsArray.some(
                (el) => el.id === newEl.id
              );
              if (!itemExist) {
                allocationsArray.push(newEl);
              }
            });
          }
        });
      }

      if (currentEmployeeData?.primary_positions?.length > 0) {
        currentEmployeeData?.primary_positions.forEach((positionAssignment) => {
          const newEl = {
            id: positionAssignment.position,
            allocation: positionAssignment.allocation,
          };
          const itemExist = allocationsArray.some((el) => el.id === newEl.id);
          if (!itemExist) {
            allocationsArray.push(newEl);
          }
        });
      }

      if (allPositions) {
        const positionsWithAllocation = allPositions.map((el) => {
          const allocationItem = allocationsArray.find(
            (allocItem) => allocItem.id === el.id
          );
          return {
            ...el,
            allocation: allocationItem ? allocationItem.allocation : 0,
          };
        });

        return positionsWithAllocation.filter((el) => {
          const positionVacancy = (el?.capacity || 0) - (el?.allocation || 0);
          return (
            positionVacancy &&
            employeeVacant >= positionVacancy &&
            positionVacancy >= 1 && // does not show positions with 0.5 for now
            el.status == "active"
          );
        });
      }
      return [];
    },

    statusConfig() {
      // Read status from employeeData first for immediate updates, then fallback to store
      // This ensures real-time updates when employeeData changes
      const dataStatus =
        this.employeeData?.current_status || this.employeeData?.status;
      const storeStatus =
        this.$store.getters["employeeStore/currentEmployeeStatus"];
      const status = dataStatus || storeStatus;

      const isArchived =
        this.employeeData?.archived ||
        this.$store.getters["employeeStore/isCurrentEmployeeArchived"];

      const statuses = {
        draft: {
          title: "Employee Not Yet Activated",
          description:
            "This employee is currently in draft status. Activate them to unlock the Path to readiness and start tracking their progress.",
          btnTitle: "Activate",
        },
        active: {
          title: "No Position Assigned Yet",
          description:
            "To track this employee's readiness, assign them to a position first.",
          btnTitle: "Assign",
        },
        terminated_unarchived: {
          title: "Employee Status: Terminated",
          description:
            "This employee's Path to readiness is unavailable because they have been terminated. Re-activate them to resume tracking their progress.",
          btnTitle: "Re-Activate",
        },
        terminated_archived: {
          title: "Employee Status: Archived",
          description:
            "This employee's Path to readiness is unavailable because they have been archived. To resume tracking their progress, unarchive and re-activate them.",
          btnTitle: "Re-Activate",
        },
      };

      if (status === "terminated") {
        return isArchived
          ? statuses.terminated_archived
          : statuses.terminated_unarchived;
      }

      return (
        statuses[status] || {
          title: "",
          description: "",
          btnTitle: "",
        }
      );
    },

    title() {
      return this.statusConfig.title;
    },

    description() {
      return this.statusConfig.description;
    },

    btnTitle() {
      return this.statusConfig.btnTitle;
    },
    employeeInfo() {
      return this.$store.getters["employeeStore/currentEmployee"];
    },
    // Computed property to watch Pinia store for reactivity
    piniaCurrentEmployee() {
      return this.employeeStore.currentEmployee;
    },
    isNewLayoutEnabled() {
      return this.$store.getters["featureFlags/isNewDesign"];
    },
    employeeStatus() {
      // Force reactivity by reading from both store and local data
      const storeStatus =
        this.$store.getters["employeeStore/currentEmployeeStatus"];
      const dataStatus =
        this.employeeData?.current_status || this.employeeData?.status;
      return storeStatus || dataStatus || "draft";
    },
    currentEmployeeStatus() {
      // Force immediate status update by reading directly from employeeData first, then store
      // This ensures the status updates immediately when employeeData changes
      const dataStatus =
        this.employeeData?.current_status || this.employeeData?.status;
      const storeStatus =
        this.$store.getters["employeeStore/currentEmployeeStatus"];
      // Prioritize dataStatus to ensure immediate update
      return dataStatus || storeStatus || "draft";
    },
    employeeFullName() {
      if (this.employeeData?.first_name && this.employeeData?.last_name) {
        return `${this.employeeData.first_name} ${this.employeeData.last_name}`;
      }
      return this.employeeData?.name || "Employee";
    },
    isArchived() {
      return (
        this.$store.getters["employeeStore/isCurrentEmployeeArchived"] ||
        this.employeeData?.archived ||
        false
      );
    },
    isTracking() {
      // Check if employee has tracking enabled (has positions assigned)
      return !!(this.employeeData?.primary_positions?.length > 0);
    },
    lastMonthReadiness() {
      // Get from weeklyReadinessData if available, or from employeeData
      if (this.weeklyReadinessData && this.weeklyReadinessData.length > 0) {
        // Return the second to last week's readiness (last month)
        return (
          this.weeklyReadinessData[this.weeklyReadinessData.length - 2] || null
        );
      }
      return this.employeeData?.last_month_readiness || null;
    },
    breadcrumbsList() {
      const currentPath = this.$route?.path || "";
      const employeesHref =
        currentPath && currentPath.startsWith("/new-organization")
          ? "/new-organization/employees"
          : "/organization/employees";

      return [
        {
          text: "Employees",
          disabled: false,
          href: employeesHref,
        },
        {
          text: this.employeeFullName,
          disabled: true,
          truncate: true,
        },
      ];
    },
  },
  methods: {
    async openChatterDrawer(data) {
      // Determine the type based on the data structure
      // data comes from PathToReadinessTreeList as options.data
      const itemData = data?.data || data;

      // Check if it's a badge (has badge property)
      if (itemData?.badge && itemData.badge.id) {
        // It's a badge chatter
        this.selectedBadgeChatter = itemData.badge;
        this.chatterType = "badge";
        this.chatterTypeValue = this.getBadgeLevelName(itemData.badge.level);
        this.chatterIconName = "org_icon_responsibility";
      } else if (
        itemData?.id &&
        itemData?.assignmentType === "responsibility"
      ) {
        // It's a responsibility chatter
        this.selectedBadgeChatter = itemData;
        this.chatterType = "responsibility";
        this.chatterTypeValue = itemData.name || "";
        this.chatterIconName = "org_icon_responsibility";
      } else {
        // Fallback: try to determine from available data
        if (itemData?.id) {
          this.selectedBadgeChatter = itemData;
          this.chatterType = "responsibility"; // Default to responsibility
          this.chatterTypeValue = itemData.name || "";
          this.chatterIconName = "org_icon_responsibility";
        } else {
          console.warn("Unable to determine chatter type for data:", data);
          return;
        }
      }

      // Reset chatter data when opening drawer
      this.chatterData = [];
      this.chatterPage = 1;
      this.totalChatter = 0;
      this.showChatterDrawer = true;

      // Fetch chatter data
      await this.fetchChatter();
    },
    closeChatterDrawer() {
      this.showChatterDrawer = false;
      this.selectedBadgeChatter = null;
      this.chatterData = [];
      this.chatterPage = 1;
      this.totalChatter = 0;
      this.chatterType = null;
      this.chatterTypeValue = null;
      this.chatterIconName = null;
    },
    async fetchChatter() {
      if (
        this.chatterLoading ||
        !this.selectedBadgeChatter ||
        !this.selectedBadgeChatter.id ||
        !this.chatterType
      )
        return;

      this.chatterLoading = true;
      try {
        const accountID = JSON.parse(localStorage.getItem("currentAccountID"));
        const recordId = this.selectedBadgeChatter.id;

        const { data } = await getChatterList(
          accountID,
          recordId,
          this.chatterType,
          this.chatterPage
        );

        if (data && data.count) {
          this.totalChatter = data.count;
        }

        if (data && data.results) {
          const chatterItems = data.results.map((el) => {
            const date = new Date(el.recorded_on);
            const milliseconds = date.getTime();
            const millisecondsString = milliseconds.toString();
            const nameParts = el.recorded_by_name
              ? el.recorded_by_name.split(" ")
              : [""];

            const newEl = {
              id: el.id,
              IsExIQtiveBot: false,
              message: el.note,
              created_on: millisecondsString,
              IsHistory: el.is_history,
            };

            if (nameParts.length >= 2) {
              newEl.avatar = {
                picture: "",
                firstName: nameParts[0],
                lastName: nameParts.slice(1).join(" "),
              };
            } else {
              newEl.avatar = {
                picture: "",
                firstName: el.recorded_by_name || "",
                lastName: "",
              };
            }

            return newEl;
          });

          this.chatterData.push(...chatterItems);
        }
      } catch (error) {
        console.error("Error fetching chatter:", error);
      } finally {
        this.chatterLoading = false;
      }
    },
    async loadMoreChatter() {
      if (this.chatterLoading) return;
      this.chatterPage += 1;
      await this.fetchChatter();
    },
    getBadgeLevelName(level) {
      if (typeof level === "string") {
        return level.charAt(0).toUpperCase() + level.slice(1);
      }
      const levelMap = {
        1: "Apprentice",
        2: "Professional",
        3: "Coach",
        4: "Master",
      };
      return levelMap[level] || "Apprentice";
    },
    // async fetchAvailablePositions(
    //   page = 1,
    //   searchTerm = "",
    //   isLoadMore = false
    // ) {
    //   const limit = 10;
    //   const offset = (page - 1) * limit;
    //   const name = searchTerm || "";
    //   try {
    //     this.primaryPositions.isLoadingMore = true;
    //     const response = await getListOfPositionsForAssignment({
    //       accountId: this.cachedAccountID,
    //       limit,
    //       offset,
    //       name,
    //     });
    //     const positions = (response.data && response.data.results) || [];
    //     let newItems = positions.map((position) => ({
    //       id: position.id,
    //       code: position.code_str.match(/\d+/)[0],
    //       code_str: position.code_str,
    //       name: position.name,
    //       status: position.status,
    //     }));

    //     // Filter out positions if current employee has preparing_for_positions matching them
    //     if (
    //       this.employeeData &&
    //       this.employeeData.preparing_for_positions &&
    //       this.employeeData.preparing_for_positions.length > 0
    //     ) {
    //       const preparingCodeStr =
    //         this.employeeData.preparing_for_positions[0].code_str;
    //       newItems = newItems.filter(
    //         (item) => item.code_str !== preparingCodeStr
    //       );
    //     }
    //     if (isLoadMore && this.primaryPositions.availablePositions) {
    //       this.primaryPositions.availablePositions = [
    //         ...this.primaryPositions.availablePositions,
    //         ...newItems,
    //       ];
    //     } else {
    //       // If it's initial load or search, replace items
    //       this.primaryPositions.availablePositions = newItems;
    //     }
    //     // Update pagination state
    //     this.primaryPositions.currentPage = page;
    //     this.primaryPositions.totalCount = response.data.count || 0;
    //     // hasMoreData should be true if there are more records beyond current page
    //     this.primaryPositions.hasMoreData =
    //       page * limit < this.primaryPositions.totalCount;
    //     this.primaryPositions.isLoadingMore = false;
    //   } catch (error) {
    //     console.error("Error fetching available positions:", error);
    //   }
    // },
    // async loadMorePrimaryPositions() {
    //   if (
    //     this.primaryPositions.isLoadingMore ||
    //     !this.primaryPositions.hasMoreData
    //   ) {
    //     return;
    //   }

    //   const nextPage = this.primaryPositions.currentPage + 1;
    //   await this.fetchAvailablePositions(
    //     nextPage,
    //     this.primaryPositions.currentSearchTerm,
    //     true
    //   );
    // },

    // // Method to handle search with pagination reset
    // async searchPrimaryPositions(searchTerm) {
    //   this.primaryPositions.currentSearchTerm = searchTerm;
    //   this.primaryPositions.currentPage = 1;
    //   this.primaryPositions.hasMoreData = true;
    //   await this.fetchAvailablePositions(
    //     this.primaryPositions.currentPage,
    //     this.primaryPositions.currentSearchTerm,
    //     false
    //   );
    // },
    async handleEmployeeUpdate() {
      await this.getEmployeeData();
      await this.reloadDataAfterChanges();
    },
    // Helper method to clear Path to Readiness data when employee is terminated
    clearPathToReadinessData() {
      this.dataSource = [];
      this.pagination.total = 0;
      this.treeListKey++;
      this.loadedChildData.clear();
      this.expandedKeys = [];
      this.weeklyReadinessData = [];
      this.$forceUpdate();
    },
    // Helper method to update employee data and clear Path to Readiness if terminated
    async updateEmployeeDataForTermination(employeeData) {
      // Normalize status field
      const normalized = {
        ...employeeData,
        status: employeeData.status || employeeData.current_status,
        current_status: employeeData.current_status || employeeData.status,
      };

      // Update both stores FIRST (same pattern as reactivateEmployee)
      // This ensures statusConfig computed property updates immediately
      this.$store.commit("employeeStore/setCurrentEmployee", normalized);
      this.employeeStore.setCurrentEmployee(normalized);

      // CRITICAL: Force update employeeData using Vue.set to ensure reactivity
      // This is the EXACT same pattern used in reactivateEmployee that makes it work
      this.$set(this, "employeeData", { ...normalized });

      // Force Vue to recognize the change immediately
      await this.$nextTick();
      this.$forceUpdate();

      // Clear Path to Readiness data
      this.clearPathToReadinessData();
    },
    async handleEmployeeStatusChanged() {
      const empId =
        this.cachedEmpId ||
        this.$route?.params?.id ||
        this.$route?.query?.employeeId;
      const accountID =
        this.cachedAccountID ||
        JSON.parse(localStorage.getItem("currentAccountID"));

      if (!empId || !accountID) {
        this.$emit("employeeStatusChanged");
        return;
      }

      try {
        // Always fetch fresh employee data from API immediately to get latest status
        const freshEmployeeData = await this.employeeStore.fetchCurrentEmployee(
          empId,
          true
        );

        if (!freshEmployeeData) {
          this.$emit("employeeStatusChanged");
          return;
        }

        // Normalize status field - ensure both status and current_status are set
        const normalizedEmployeeData = {
          ...freshEmployeeData,
          status: freshEmployeeData.status || freshEmployeeData.current_status,
          current_status:
            freshEmployeeData.current_status || freshEmployeeData.status,
        };

        // Update both stores immediately (same pattern as reactivateEmployee)
        this.$store.commit(
          "employeeStore/setCurrentEmployee",
          normalizedEmployeeData
        );
        this.employeeStore.setCurrentEmployee(normalizedEmployeeData);

        // Get current status before updating employeeData
        const oldStatus = (
          this.employeeData?.current_status ||
          this.employeeData?.status ||
          ""
        ).toLowerCase();

        // CRITICAL: Force update employeeData using Vue.set to ensure reactivity
        // This is the same pattern used in reactivateEmployee that makes it work
        this.$set(this, "employeeData", { ...normalizedEmployeeData });

        // Force Vue to recognize the change immediately
        await this.$nextTick();
        this.$forceUpdate();

        // Check status from the fresh API data
        const statusToCheck = (
          normalizedEmployeeData.current_status ||
          normalizedEmployeeData.status ||
          ""
        ).toLowerCase();

        // If status is terminated, clear Path to Readiness data immediately
        if (statusToCheck === "terminated") {
          // Clear Path to Readiness data immediately (statusConfig will update via computed property)
          this.clearPathToReadinessData();
          this.$emit("employeeStatusChanged");

          // Delayed API refresh after 2-3 seconds to ensure backend has processed the changes
          setTimeout(async () => {
            try {
              const delayedFreshData =
                await this.employeeStore.fetchCurrentEmployee(empId, true); // forceRefresh
              if (delayedFreshData) {
                const normalizedDelayedData = {
                  ...delayedFreshData,
                  status:
                    delayedFreshData.status || delayedFreshData.current_status,
                  current_status:
                    delayedFreshData.current_status || delayedFreshData.status,
                };
                this.$store.commit(
                  "employeeStore/setCurrentEmployee",
                  normalizedDelayedData
                );
                this.employeeStore.setCurrentEmployee(normalizedDelayedData);
                this.$set(this, "employeeData", { ...normalizedDelayedData });
                await this.$nextTick();
                this.$forceUpdate();
                this.$emit("employeeStatusChanged");
              }
            } catch (error) {
              console.error("Error in delayed employee status refresh:", error);
            }
          }, 2500); // 2.5 seconds delay
          return;
        } else if (
          oldStatus === "terminated" &&
          statusToCheck !== "terminated"
        ) {
          // If employee was reactivated, do full refresh
          await this.handleRefreshEmployeeData();
        } else {
          // For other status changes, do full refresh
          await this.handleRefreshEmployeeData();
        }
      } catch (error) {
        // Fallback: try to get from store
        const fallbackEmployeeData =
          this.employeeStore.currentEmployee ||
          this.$store.getters["employeeStore/currentEmployee"];

        if (fallbackEmployeeData) {
          const normalized = {
            ...fallbackEmployeeData,
            status:
              fallbackEmployeeData.status ||
              fallbackEmployeeData.current_status,
            current_status:
              fallbackEmployeeData.current_status ||
              fallbackEmployeeData.status,
          };
          this.$set(this, "employeeData", { ...normalized });
          this.$forceUpdate();

          const statusToCheck = (
            normalized.current_status ||
            normalized.status ||
            ""
          ).toLowerCase();

          if (statusToCheck === "terminated") {
            // Use helper method to clear Path to Readiness data
            this.clearPathToReadinessData();
          }
        }
      }

      this.$emit("employeeStatusChanged");
    },
    async handleEmployeeDeleted() {
      // Redirect to employees list when employee is deleted
      this.$router.push({ name: "Employees" });
    },
    async handleRefreshEmployeeData() {
      // Force a complete refresh of employee data from API
      return await this.initializeData(true);
    },
    getEmpAndAccountIds() {
      // Always get the latest employeeId from route, don't rely on cached value
      const empId =
        this.$route?.params?.id ||
        this.$route?.query?.employeeId ||
        this.cachedEmpId;

      // Update cached value if we got a new one from route
      if (empId && empId !== this.cachedEmpId) {
        this.cachedEmpId = empId;
      }

      // Validate that we have a valid employeeId
      if (!empId || empId === "undefined" || empId === "null") {
        console.error("Invalid employeeId:", empId);
        return {
          empId: null,
          accountID:
            this.cachedAccountID ||
            JSON.parse(localStorage.getItem("currentAccountID")),
        };
      }

      return {
        empId: String(empId), // Ensure it's a string
        accountID:
          this.cachedAccountID ||
          JSON.parse(localStorage.getItem("currentAccountID")),
      };
    },
    shouldFetchEmployee(force, employeeData, empId) {
      return (
        force ||
        !employeeData ||
        Object.keys(employeeData).length === 0 ||
        employeeData.id != empId
      );
    },
    async fetchAndSetEmployeeData(empId) {
      try {
        const employeeData = await this.employeeStore.fetchCurrentEmployee(
          empId,
          true
        );
        if (employeeData) {
          this.$store.commit("employeeStore/setCurrentEmployee", employeeData);
          this.employeeStore.setCurrentEmployee(employeeData);
        }
        return employeeData;
      } catch (error) {
        console.error("Error fetching employee data:", error);
        if (error.response && error.response.status === 404) {
          return null;
        }
        throw error;
      }
    },
    applyEmployeeToState(employeeData) {
      this.employeeData = employeeData;
      this.currentReadiness = {
        current_readiness: employeeData.current_readiness,
      };
    },
    isTerminatedEmployee(employeeData) {
      const status = employeeData?.current_status || employeeData?.status || "";
      return status.toLowerCase() === "terminated";
    },
    async loadAssignmentsAndWeeklyData(accountID, empId) {
      const [assignmentsResponse, weeklyDataResponse] = await Promise.all([
        getEmployeeAssignments(
          accountID,
          empId,
          this.pagination.limit,
          this.pagination.offset,
          "active"
        ),
        this.fetchWeeklyReadinessData(),
      ]);
      if (assignmentsResponse.data) {
        this.pagination.total = assignmentsResponse.data.count || 0;
        this.dataSource =
          assignmentsResponse.data.results?.length > 0
            ? this.transformData(assignmentsResponse.data.results)
            : [];
      }
      if (weeklyDataResponse) {
        this.weeklyReadinessData = weeklyDataResponse;
      }
    },
    resetTreeListState() {
      this.treeListKey++;
      this.expandedKeys = [];
      this.loadedChildData.clear();
    },
    async initializeData(force = false) {
      if (this.isLoadingData) return true;

      this.isLoadingData = true;
      this.$loader.show();
      const { empId, accountID } = this.getEmpAndAccountIds();

      // Validate employeeId before proceeding
      if (!empId || empId === "undefined" || empId === "null") {
        console.error("Cannot initialize data: Invalid employeeId:", empId);
        this.$loader.hide();
        this.isLoadingData = false;
        return false;
      }

      try {
        this.loading.readinessBar = true;

        let employeeData =
          this.employeeStore.currentEmployee ||
          this.$store.getters["employeeStore/currentEmployee"];
        if (this.shouldFetchEmployee(force, employeeData, empId)) {
          employeeData = await this.fetchAndSetEmployeeData(empId);
        }

        if (!employeeData || !employeeData.id) {
          console.error("Employee data not found for ID:", empId);
          return false;
        }

        this.applyEmployeeToState(employeeData);

        // Get the latest employee data for status check
        const latestEmployeeData =
          employeeData ||
          this.employeeData ||
          this.employeeStore.currentEmployee ||
          this.$store.getters["employeeStore/currentEmployee"];

        // Check if employee is terminated - if so, don't fetch assignments
        const employeeStatus =
          latestEmployeeData?.current_status ||
          latestEmployeeData?.status ||
          "";
        const isTerminated = employeeStatus?.toLowerCase() === "terminated";

        if (isTerminated) {
          // Clear dataSource for terminated employees
          this.dataSource = [];
          this.pagination.total = 0;
        } else {
          await this.loadAssignmentsAndWeeklyData(accountID, empId);
        }

        this.resetTreeListState();
        return true;
      } catch (error) {
        console.error("Error initializing data:", error);
        return false;
      } finally {
        this.$loader.hide();
        this.loading.readinessBar = false;
        this.isLoadingData = false;
      }
    },
    async fetchWeeklyReadinessData() {
      try {
        // TODO: Replace with actual API endpoint when available
        // For now, we'll check if the employee data contains weekly readiness
        // or create sample data for testing

        // Get employee data from store (updated by sidebar component)
        const employeeData =
          this.employeeStore.currentEmployee ||
          this.$store.getters["employeeStore/currentEmployee"];

        // Check if employee data has weekly readiness history
        if (employeeData?.weekly_readiness_history) {
          return employeeData.weekly_readiness_history;
        }

        // If no weekly data available, create sample data based on current readiness
        // This should be removed when the actual API endpoint is implemented
        const currentReadiness = employeeData?.current_readiness || 0;
        const sampleWeeklyData =
          this.generateSampleWeeklyData(currentReadiness);

        return sampleWeeklyData;
      } catch (error) {
        console.error("Error fetching weekly readiness data:", error);
        return [];
      }
    },

    generateSampleWeeklyData(currentReadiness) {
      // Generate sample data for 7 weeks (6 previous weeks + current)
      // This is temporary and should be removed when real API is available
      const weeks = [];
      const baseReadiness = Math.max(0, currentReadiness - 20);

      for (let i = 0; i < 7; i++) {
        // Create slight variations around the current readiness
        const variation = Math.random() * 10 - 5; // -5 to +5 variation
        const readiness = Math.min(
          100,
          Math.max(0, baseReadiness + i * 3 + variation)
        );
        weeks.push(Math.round(readiness));
      }

      // Ensure the last week matches current readiness
      weeks[6] = currentReadiness;

      return weeks;
    },
    async fetchAvailablePositions(
      page = 1,
      searchTerm = "",
      isLoadMore = false
    ) {
      const limit = 10;
      const offset = (page - 1) * limit;
      const name = searchTerm || "";
      try {
        this.primaryPositions.isLoadingMore = true;
        const response = await getListOfPositionsForAssignment({
          accountId: this.cachedAccountID,
          limit,
          offset,
          name,
        });
        const positions = response.data?.results || [];
        let newItems = positions.map((position) => ({
          id: position.id,
          code: position.code_str.match(/\d+/)[0],
          code_str: position.code_str,
          name: position.name,
          status: position.status,
        }));

        // Filter out positions if current employee has preparing_for_positions matching them
        if (this.employeeData?.preparing_for_positions?.length > 0) {
          const preparingCodeStr =
            this.employeeData.preparing_for_positions[0].code_str;
          newItems = newItems.filter(
            (item) => item.code_str !== preparingCodeStr
          );
        }
        if (isLoadMore && this.primaryPositions.availablePositions) {
          this.primaryPositions.availablePositions = [
            ...this.primaryPositions.availablePositions,
            ...newItems,
          ];
        } else {
          // If it's initial load or search, replace items
          this.primaryPositions.availablePositions = newItems;
        }
        // Update pagination state
        this.primaryPositions.currentPage = page;
        this.primaryPositions.totalCount = response.data.count || 0;
        // hasMoreData should be true if there are more records beyond current page
        this.primaryPositions.hasMoreData =
          page * limit < this.primaryPositions.totalCount;
        this.primaryPositions.isLoadingMore = false;
      } catch (error) {
        console.error("Error fetching available positions:", error);
      }
    },
    async loadMorePrimaryPositions() {
      if (
        this.primaryPositions.isLoadingMore ||
        !this.primaryPositions.hasMoreData
      ) {
        return;
      }

      const nextPage = this.primaryPositions.currentPage + 1;
      await this.fetchAvailablePositions(
        nextPage,
        this.primaryPositions.currentSearchTerm,
        true
      );
    },

    // Method to handle search with pagination reset
    async searchPrimaryPositions(searchTerm) {
      this.primaryPositions.currentSearchTerm = searchTerm;
      this.primaryPositions.currentPage = 1;
      this.primaryPositions.hasMoreData = true;
      await this.fetchAvailablePositions(
        this.primaryPositions.currentPage,
        this.primaryPositions.currentSearchTerm,
        false
      );
    },
    showAwardBadge(obj) {
      this.isInspectResModal = false;
      this.showAwardBadgeModal = true;
      // Convert level to lowercase and handle "Novice" case
      const level = obj && obj.level ? obj.level.toLowerCase() : null;
      if (level === "novice") {
        this.awardBadgeLevel = "apprentice"; // Default to apprentice for novice
      } else if (
        ["apprentice", "professional", "coach", "master"].includes(level)
      ) {
        this.awardBadgeLevel = level;
      } else {
        this.awardBadgeLevel = "apprentice"; // Default fallback
      }
      // Set the responsibility name if provided
      if (obj?.responsibilityName) {
        this.currentSelectRes = { name: obj.responsibilityName };
      }
    },
    async awardBadge(isNotify = false) {
      // Show main loader and keep it until everything is complete
      this.$loader.show();

      try {
        const routeParams = this.$route.params;
        let responsibilityId = null;
        if (routeParams && routeParams.objId) {
          responsibilityId = routeParams.objId;
        } else if (
          this.currentResponsibility &&
          this.currentResponsibility.id
        ) {
          responsibilityId = this.currentResponsibility.id;
        }
        if (!responsibilityId) throw "no responsibility id available";
        const account = JSON.parse(localStorage.getItem("currentAccountID"));
        const data = {
          employee: this.evalModalEmpState.id,
          responsibility: responsibilityId,
          level: this.getBadgeLevelByLabel(this.awardBadgeLevel),
          given: false,
          issued_method: "awarded",
          notify: isNotify,
        };
        await createProficiencyBadge(account, data);
        // Immediately fetch fresh employee data from API to update status
        const employeeData = await this.employeeStore.fetchCurrentEmployee(
          this.employeeInfo?.id,
          true
        );
        if (employeeData) {
          // Update store and local data with fresh employee status
          this.$store.commit("employeeStore/setCurrentEmployee", employeeData);
          this.employeeData = employeeData;
        }
        await this.reloadDataAfterChanges();
        // Clear modal states after everything is complete
        this.clearModalStates();
      } catch (e) {
        console.error("❌ Error in awardBadge:", e);
        this.clearModalStates(); // Clear even on error
      } finally {
        // Hide loader only after everything is complete
        this.$loader.hide();
      }
    },

    getBadgeLevelByLabel(level) {
      switch (level.toLowerCase()) {
        case "novice":
          return 0;
        case "apprentice":
          return 1;
        case "professional":
          return 2;
        case "coach":
          return 3;
        case "master":
          return 4;
        default:
          return 0;
      }
    },
    async upgradeBadge(upgradeData) {
      try {
        this.badgeData = { payload: upgradeData?.payload?.newBadge };
        await this.onClick(false);
      } catch (e) {
        console.log(e);
      }
    },
    handleButtonClick() {
      const { id, first_name, last_name, availability, avatar, title } =
        this.employeeInfo;
      const employeeObj = {
        id,
        firstName: first_name,
        lastName: last_name,
        availability,
        picture: avatar,
        title: title,
      };
      this.currenntEmployee = JSON.parse(JSON.stringify(employeeObj));
      if (this.employeeInfo.current_status === "draft") {
        this.activateEmployee = true;
      }
      if (
        this.employeeInfo.current_status === "terminated" &&
        this.employeeInfo.archived === false
      ) {
        this.reActivateEmployee = true;
      }
      if (
        this.employeeInfo.current_status === "terminated" &&
        this.employeeInfo.archived === true
      ) {
        this.reActivateEmployee = true;
        this.unArchiveEmployee = true;
      }
      if (this.employeeInfo.current_status === "active") {
        this.fetchAvailablePositions();
        this.assignPosition = true;
      }
    },
    async processRemoveBadgeFromEvalModal(data) {
      try {
        if (!data || !data.id) throw "badge id not found";

        // Get badge level name
        const badgeLevel = data.level || data.currentBadge?.level || "";
        const badgeLevelName = this.getBadgeLevelName(badgeLevel);

        // Get responsibility name from currentSelectRes or currentResponsibility
        const responsibilityName =
          this.currentSelectRes?.name || this.currentResponsibility?.name || "";

        // Store badge info for dialog
        this.selectedBadgeForRemoval = {
          id: data.id,
          badgeName: badgeLevelName,
          responsibilityName: responsibilityName,
          badgeData: data,
        };

        // Show remove badge dialog
        this.showRemoveBadgeDialog = true;
      } catch (e) {
        console.error(e);
        this.$toast?.error("Error preparing badge removal");
      }
    },
    async handleConfirmRemoveBadge({ reason: removeReason }) {
      if (
        !this.selectedBadgeForRemoval ||
        !this.selectedBadgeForRemoval.id ||
        !removeReason?.trim()
      ) {
        this.$toast?.error("Please provide a reason for removing the badge");
        return;
      }

      this.$loader.show();
      try {
        await this.deleteBadge(
          this.selectedBadgeForRemoval.id,
          removeReason.trim(),
          "removed"
        );

        await this.reloadDataAfterChanges();

        // Clear modal states after everything is complete
        this.clearModalStates();
        this.$toast?.success("Badge removed successfully");
        this.handleCloseRemoveBadgeDialog();
      } catch (e) {
        console.error(e);
        this.$toast?.error("Error removing badge");
        // Clear modal states even on error
        this.clearModalStates();
      } finally {
        this.$loader.hide();
      }
    },
    handleCloseRemoveBadgeDialog() {
      this.showRemoveBadgeDialog = false;
      this.selectedBadgeForRemoval = null;
    },
    async deleteBadge(idBadge, reason = "", method = "") {
      try {
        const payload = {
          badge: idBadge,
          method: method || "string",
          reason: reason || "string",
        };
        const accountID = localStorage.getItem("currentAccountID");
        await deleteResponsibilityBadge(accountID, idBadge, payload);
        // Immediately fetch fresh employee data from API to update status
        const employeeData = await this.employeeStore.fetchCurrentEmployee(
          this.employeeInfo?.id,
          true
        );
        if (employeeData) {
          // Update store and local data with fresh employee status
          this.$store.commit("employeeStore/setCurrentEmployee", employeeData);
          this.employeeData = employeeData;
        }
        // Employee data will be updated by sidebar component after this operation
      } catch (e) {
        console.error("Error removing badge: ", e);
      }
    },
    onCloseModal() {
      this.activateEmployee = false;
      this.reActivateEmployee = false;
      this.unArchiveEmployee = false;
      this.assignPosition = false;
      // Clear any error messages when closing modals
      this.errorMessage = "";
    },
    dropdownItems(data) {
      const items = [];
      if (data?.data?.type === "responsibility" && !data?.data?.badge) {
        items.push({
          name: "Issue Badge",
          value: "issue_badge_action",
          icon: "plainminimalistic.svg",
          order: 2,
        });
      }
      if (data?.data?.type === "responsibility") {
        items.push({
          name: "Retire in Catalog",
          value: "retire_responsibility",
          icon: "icons/dropdown/activate.svg",
          order: 3,
        });
      }
      return items;
    },
    async reloadCheckpointsData() {
      await this.reloadDataAfterChanges();
    },
    async reloadDataAfterBadgeOperation() {
      this.$loader.show();
      // Immediately fetch fresh employee data from API to update status
      const employeeData = await this.employeeStore.fetchCurrentEmployee(
        this.employeeInfo?.id,
        true
      );
      if (employeeData) {
        // Update store and local data with fresh employee status
        this.$store.commit("employeeStore/setCurrentEmployee", employeeData);
        this.employeeData = employeeData;
      }
      await this.reloadDataAfterChanges();
      this.$loader.hide();
    },
    async grantOrForceBadge(badgeData) {
      this.isInspectResModal = false;
      this.showBadgeConfirmationDialog = true;
      this.badgeData = badgeData;
    },
    async onClick(isNotify = false) {
      // Show main loader and keep it until everything is complete
      this.$loader.show();

      try {
        const accountID =
          this.cachedAccountID ||
          JSON.parse(localStorage.getItem("currentAccountID"));
        const newPayload = {
          level: this.badgeData.payload.level,
          employee: this.badgeData.payload.employee,
          given: this.badgeData.payload.given,
          responsibility: this.badgeData.payload.responsibility,
          issued_method: this.badgeData.payload.issued_method,
          notify: isNotify,
        };

        await createProficiencyBadge(accountID, newPayload);
        // Immediately fetch fresh employee data from API to update status
        const employeeData = await this.employeeStore.fetchCurrentEmployee(
          this.employeeInfo?.id,
          true
        );
        if (employeeData) {
          // Update store and local data with fresh employee status
          this.$store.commit("employeeStore/setCurrentEmployee", employeeData);
          this.employeeData = employeeData;
        }

        await this.reloadDataAfterChanges();

        // Clear modal states after everything is complete
        this.clearModalStates();
      } catch (error) {
        console.error("❌ Error in onClick:", error);
        this.clearModalStates(); // Clear even on error
      } finally {
        // Hide loader only after everything is complete
        this.$loader.hide();
      }
    },
    async loadData() {
      const empId = this.cachedEmpId || this.$route?.params?.id;
      const accountID =
        this.cachedAccountID ||
        JSON.parse(localStorage.getItem("currentAccountID"));
      this.$loader.show();

      try {
        await Promise.all([
          // this.getAuthUser(empId),
          this.getEmpAssignments(accountID, empId),
        ]);

        const responsibilitiesIdsNew = [];
        const uniqueRespIds = [...new Set(this.responsibilitiesToUseIds)];

        uniqueRespIds.forEach((respId) => {
          const respObj = this.allResponsibilities.find(
            (el) => el.id == respId
          );
          if (respObj) {
            responsibilitiesIdsNew.push({
              id: respObj.id,
              code: respObj.code_str,
            });
          }
        });
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.$loader.hide();
      }
    },
    async loadAllCheckpointsEvaluationData(
      accountId,
      employeeId,
      responsibilityId
    ) {
      const response = await getListActiveCheckpointsEval(
        accountId,
        responsibilityId,
        employeeId
      );
      return response.data;
    },
    async getEmpAssignments(accountId, empId) {
      // Prevent duplicate calls
      if (this.isLoadingData) {
        return;
      }

      this.isLoadingData = true;
      try {
        const { data } = await getEmployeeAssignments(
          accountId,
          empId,
          this.pagination.limit,
          this.pagination.offset,
          "active"
        );

        if (data) {
          this.pagination.total = data.count || 0;

          if (data.results?.length > 0) {
            this.dataSource = this.transformData(data.results);
          } else {
            this.dataSource = [];
          }
        }
      } finally {
        this.isLoadingData = false;
      }
    },
    async onEmployeeReadiness() {
      const empId = this.cachedEmpId || this.$route?.params?.id;
      if (empId) {
        this.$parent.$refs?.employeeSideBar?.recalculateEmployeeReadiness(
          empId
        );

        const employeeData =
          this.employeeStore.currentEmployee ||
          this.$store.getters["employeeStore/currentEmployee"];
        if (employeeData) {
          this.employeeData = employeeData;
        }
      }
    },
    async reloadDataAfterChanges() {
      const empId =
        this.cachedEmpId ||
        this.$route.params.id ||
        this.$route.query.employeeId;
      const accountID =
        this.cachedAccountID ||
        JSON.parse(localStorage.getItem("currentAccountID"));

      try {
        this.loading.readinessBar = true;
        this.preserveExpansionState();

        // Force refresh employee data from API to get latest position assignments
        const freshEmployeeData = await this.employeeStore.fetchCurrentEmployee(
          empId,
          true // forceRefresh
        );

        if (freshEmployeeData) {
          // Update stores with fresh data
          this.$store.commit(
            "employeeStore/setCurrentEmployee",
            freshEmployeeData
          );
          this.employeeStore.setCurrentEmployee(freshEmployeeData);
          // Update local employeeData with fresh data
          this.$set(this, "employeeData", { ...freshEmployeeData });
          await this.$nextTick();
        } else {
          // Fallback to getEmployeeData if fetchCurrentEmployee fails
          await this.getEmployeeData();
          const employeeData =
            this.employeeStore.currentEmployee ||
            this.$store.getters["employeeStore/currentEmployee"];
          if (employeeData) {
            this.$set(this, "employeeData", { ...employeeData });
          }
        }

        this.$parent.$refs?.employeeSideBar?.recalculateEmployeeReadiness(
          empId
        );

        const weeklyDataResponse = await this.fetchWeeklyReadinessData();
        if (weeklyDataResponse) {
          this.weeklyReadinessData = weeklyDataResponse;
        }

        // Get the latest employee data for status check
        const latestEmployeeData =
          freshEmployeeData ||
          this.employeeData ||
          this.employeeStore.currentEmployee ||
          this.$store.getters["employeeStore/currentEmployee"];

        // Check if employee is terminated - if so, don't fetch assignments
        const employeeStatus =
          latestEmployeeData?.current_status ||
          latestEmployeeData?.status ||
          "";
        const isTerminated = employeeStatus?.toLowerCase() === "terminated";

        if (!isTerminated && !this.$route.path.includes("badges")) {
          await this.getEmpAssignments(accountID, empId);
          await this.refreshExpandedChildData(accountID, empId);
          this.treeListKey++;

          this.$nextTick(() => {
            this.$nextTick(() => {
              this.restoreExpansionState();
            });
          });
        } else if (isTerminated) {
          // Clear dataSource for terminated employees
          this.dataSource = [];
          this.pagination.total = 0;
          this.treeListKey++;
        }
      } catch (error) {
        console.error("Error reloading data:", error);
      } finally {
        this.loading.readinessBar = false;
      }
    },

    transformData(dataArray) {
      const result = [];
      const today = new Date();

      dataArray.forEach((data) => {
        // Transform position data
        const positionObject = this.transformPositionData(data, today);
        result.push(positionObject);

        // TODO: Later - handle role assignments when API is added
        // if (data.role_assignment_count > 0) {
        //   // Will call roles API and process role_assignments
        // }
      });

      // Sort the results by commitment level
      const commitmentOrder = {
        Primary: 1,
        "Preparing for": 2,
        Backup: 3,
      };

      result.sort((a, b) => {
        const aCommit = a.data?.commitmentLevel || "";
        const bCommit = b.data?.commitmentLevel || "";
        return (
          (commitmentOrder[aCommit] || 99) - (commitmentOrder[bCommit] || 99)
        );
      });

      return result;
    },

    transformPositionData(data, today) {
      const isNew =
        new Date(data.assigned_on).getTime() + 10 * 24 * 60 * 60 * 1000 >
        today.getTime();

      return {
        id: `position_${data.id}`, // Make position IDs unique
        parentId: -1, // Root-level has no parent
        data: {
          type: data.assignment_type,
          commitmentLevel: data.commitment_level,
          assignmentType: data.assignment_type,
          importanceLevel: data.importance,
          importanceSelector: true,
          totalSteps: 3,
          code: data.position_code,
          name: data.position_name,
          isNew: isNew,
          isAccepted: false,
          acceptanceStatus: "pending",
          // Add expandable indicator if roles exist
          hasRoles: data.role_assignment_count > 0,
          roleCount: data.role_assignment_count,
        },
        assignment_id: data.id,
        status: data.status,
        readiness: data.current_readiness,
      };
    },

    transformRoleData(role, parentId, today) {
      const isRoleNew =
        new Date(role.assigned_on).getTime() + 10 * 24 * 60 * 60 * 1000 >
        today.getTime();

      // Map API status to acceptanceStatus for AcceptanceStatusBadge component
      // AcceptanceStatusBadge only supports: "pending", "accepted", "rejected"
      // For non-active statuses (terminated, relieved, detached, etc.), don't show acceptance status badge
      // For active roles, check if they're new (pending) or accepted
      let acceptanceStatus = null;
      if (role.status === "active") {
        acceptanceStatus = isRoleNew ? "pending" : "accepted";
      }
      // For terminated/relieved/detached/etc., acceptanceStatus remains null so badge won't show
      // The actual status will be displayed via the status field

      return {
        id: `role_${role.id}`, // Make role IDs unique
        parentId: parentId, // Set parent ID to main object
        data: {
          type: role.assignment_type,
          commitmentLevel: role.commitment_level,
          assignmentType: role.assignment_type,
          importanceLevel: role.importance,
          importanceSelector: true,
          totalSteps: 3,
          code: role.role_code,
          name: role.role_name,
          isNew: isRoleNew,
          isAccepted: !isRoleNew && role.status === "active",
          acceptanceStatus: acceptanceStatus,
          assignment_id: parentId,
          // Add expandable indicator if responsibilities exist
          hasResponsibilities: role.responsibility_assignment_count > 0,
          responsibilityCount: role.responsibility_assignment_count,
          // Include additional fields from API
          assignedOn: role.assigned_on,
          removedOn: role.removed_on,
          assignedBy: role.assigned_by,
          removedBy: role.removed_by,
          reason: role.reason,
        },
        assignment_id: role.id,
        status: role.status || "active", // Use actual status from API (terminated, relieved, detached, active, etc.)
        readiness: role.current_readiness,
      };
    },

    transformResponsibilityData(resp, parentId, assignmentId, today) {
      let checkpoints = [];
      const isRespNew =
        new Date(resp.assigned_on).getTime() + 10 * 24 * 60 * 60 * 1000 >
        today.getTime();

      return {
        id: `responsibility_${resp.id}`, // Make responsibility IDs unique
        parentId: parentId, // Correctly set parent ID
        data: {
          type: resp.assignment_type,
          commitmentLevel: resp.commitment_level,
          assignmentType: resp.assignment_type,
          importanceLevel: resp.importance,
          importanceSelector: true,
          totalSteps: 3,
          code: resp.responsibility_code,
          name: resp.responsibility_name,
          isNew: isRespNew,
          isAccepted: isRespNew,
          acceptanceStatus: "pending",
          assignment_id: assignmentId,
          badge: resp.badge,
          responsibility_id: 1310,
        },
        checkpointsData: checkpoints,
        status: resp.status,
        readiness: resp.current_readiness,
      };
    },

    transformResponsibilityDataFromAPI(resp, parentId, assignmentId, today) {
      const checkpoints = [];
      const isRespNew =
        new Date(resp.assigned_on).getTime() + 10 * 24 * 60 * 60 * 1000 >
        today.getTime();

      let badge = null;
      if (resp.badge_level !== null && resp.badge_status !== "expired") {
        badge = {
          id: resp.badge_id,
          level: resp.badge_level,
          status: resp.badge_issued_method,
          expiration_date: resp.badge_expiration_date,
          issued_method: resp.badge_issued_method,
        };
      }

      // Extract checkpoint counts from API response
      const checkpointCounts = {
        apprentice_checkpoint_count: resp.apprentice_checkpoint_count || 0,
        professional_checkpoint_count: resp.professional_checkpoint_count || 0,
        coach_checkpoint_count: resp.coach_checkpoint_count || 0,
        master_checkpoint_count: resp.master_checkpoint_count || 0,
        apprentice_passed_checkpoint_count:
          resp.apprentice_passed_checkpoint_count || 0,
        professional_passed_checkpoint_count:
          resp.professional_passed_checkpoint_count || 0,
        coach_passed_checkpoint_count: resp.coach_passed_checkpoint_count || 0,
        master_passed_checkpoint_count:
          resp.master_passed_checkpoint_count || 0,
        active_checkpoints_count:
          resp.apprentice_checkpoint_count +
          resp.professional_checkpoint_count +
          resp.coach_checkpoint_count +
          resp.master_checkpoint_count,
      };
      // Map API status to acceptanceStatus for AcceptanceStatusBadge component
      // AcceptanceStatusBadge only supports: "pending", "accepted", "rejected"
      // For non-active statuses (terminated, relieved, detached, etc.), don't show acceptance status badge
      // For active responsibilities, check if they're new (pending) or accepted
      let acceptanceStatus = null;
      if (resp.status === "active") {
        acceptanceStatus = isRespNew ? "pending" : "accepted";
      }
      // For terminated/relieved/detached/etc., acceptanceStatus remains null so badge won't show
      // The actual status will be displayed via the status field

      // Map available_inspectors to avatars format for display
      // Only show inspectors if employee doesn't have Master badge level (they can inspect themselves)
      const avatars =
        resp.badge_level === "Master" || resp.current_badge_level === "Master"
          ? []
          : (resp.available_inspectors || []).map((inspector) => {
              // Split full_name into firstName and lastName
              const nameParts = (inspector.full_name || "").trim().split(/\s+/);
              const firstName = nameParts[0] || "";
              const lastName = nameParts.slice(1).join(" ") || "";

              // Try to find badge level from badge_holders by matching name
              const badgeHolder = (resp.badge_holders || []).find((bh) => {
                const badgeHolderFullName = `${bh.first_name || ""} ${
                  bh.last_name || ""
                }`.trim();
                return (
                  badgeHolderFullName === (inspector.full_name || "").trim()
                );
              });

              return {
                id: inspector.id,
                badgeLevel: badgeHolder?.badge_level || null,
                firstName: firstName,
                lastName: lastName,
                fullName: inspector.full_name || "",
                title: badgeHolder?.title || null,
                master_will_coach: badgeHolder?.master_will_coach || null,
                img: inspector.avatar || "",
                isHoverEnabled: !!inspector.avatar,
              };
            });

      return {
        id: `responsibility_${resp.id}`, // Make responsibility IDs unique
        parentId: parentId, // Correctly set parent ID
        data: {
          type: resp.assignment_type,
          commitmentLevel: resp.commitment_level,
          assignmentType: resp.assignment_type,
          importanceLevel: resp.importance,
          importanceSelector: true,
          totalSteps: 3,
          code: resp.responsibility_code,
          name: resp.responsibility_name,
          isNew: isRespNew,
          isAccepted: !isRespNew && resp.status === "active",
          acceptanceStatus: acceptanceStatus,
          assignment_id: assignmentId,
          badge: badge,
          responsibility_id: resp.responsibility,
          checkpointCounts: checkpointCounts,
          avatars: avatars, // Available inspectors mapped to avatars format
        },
        checkpointsData: checkpoints,
        status: resp.status || "active", // Use actual status from API (terminated, relieved, detached, active, etc.)
        readiness: resp.current_readiness,
      };
    },

    async getAllResponsibilities() {
      try {
        const accountID =
          this.cachedAccountID || localStorage.getItem("currentAccountID");
        const data = await getListofResponsibility(accountID);
        this.allResponsibilities = data.data.results;
      } catch (error) {
        console.error("Error fetching responsibilities:", error);
      }
    },
    async onTreeExpandRole({ assignmentId, rowType, expandedRowData }) {
      const accountID = window.localStorage.getItem("currentAccountID");
      const empId = this.$route.params.id || this.$route.query.employeeId;

      // Check if data is already loaded for this expansion
      const cacheKey = `${rowType}_${assignmentId}`;
      if (this.loadedChildData.has(cacheKey)) {
        return;
      }

      // Remove skeleton loaders using the correct parent ID format
      const parentId =
        rowType === "position"
          ? `position_${assignmentId}`
          : expandedRowData.id;
      this.removeSkeletonLoaders(parentId);

      try {
        if (rowType === "position") {
          await this.handlePositionExpansion(accountID, empId, assignmentId);
          // Mark this position's roles as loaded
          this.loadedChildData.set(cacheKey, true);
        } else if (rowType === "role") {
          await this.handleRoleExpansion(
            accountID,
            empId,
            assignmentId,
            expandedRowData
          );
          // Mark this role's responsibilities as loaded
          this.loadedChildData.set(cacheKey, true);
        }
      } catch (error) {
        console.error("Error loading assignments:", error);
        // Remove skeleton loaders using the correct parent ID format
        const parentId =
          rowType === "position"
            ? `position_${assignmentId}`
            : expandedRowData.id;
        this.removeSkeletonLoaders(parentId);
      }
    },

    async handlePositionExpansion(accountID, empId, positionAssignmentId) {
      const existingRoles = this.dataSource.filter(
        (item) =>
          item.parentId === `position_${positionAssignmentId}` &&
          item.data?.type === "role" &&
          !item.data?.isSkeletonLoader
      );

      if (existingRoles.length > 0) {
        return;
      }

      const positionData = this.dataSource.find(
        (item) => item.id === `position_${positionAssignmentId}`
      );
      const roleCount = positionData?.data?.roleCount || 2; // fallback to 2 if not found

      this.addSkeletonLoaders(
        `position_${positionAssignmentId}`,
        "position",
        roleCount
      );

      const response = await getRoleAssignment(
        accountID,
        empId,
        positionAssignmentId,
        null // Fetch all statuses (active, terminated, relieved, etc.)
      );

      this.removeSkeletonLoaders(`position_${positionAssignmentId}`);

      if (
        response.data &&
        response.data.results &&
        response.data.results.length > 0
      ) {
        const today = new Date();
        const roleData = response.data.results;

        const transformedRoles = roleData.map((role) =>
          this.transformRoleData(
            role,
            `position_${positionAssignmentId}`,
            today
          )
        );

        this.dataSource = [...this.dataSource, ...transformedRoles];

        const positionIndex = this.dataSource.findIndex(
          (item) => item.id === `position_${positionAssignmentId}`
        );
        if (positionIndex !== -1) {
          this.dataSource[positionIndex].data.hasRoles = true;
          this.dataSource[positionIndex].data.roleCount =
            transformedRoles.length;
        }
      }
    },

    async handleRoleExpansion(
      accountID,
      empId,
      roleAssignmentId,
      expandedRowData
    ) {
      const existingResponsibilities = this.dataSource.filter(
        (item) =>
          item.parentId === expandedRowData.id &&
          item.data?.type === "responsibility" &&
          !item.data?.isSkeletonLoader
      );

      if (existingResponsibilities.length > 0) {
        return;
      }

      const responsibilityCount =
        expandedRowData.data?.responsibilityCount || 3; // fallback to 3 if not found

      this.addSkeletonLoaders(expandedRowData.id, "role", responsibilityCount);

      const response = await getResponsibilityAssignment(
        accountID,
        roleAssignmentId,
        "active",
        "active"
      );

      this.removeSkeletonLoaders(expandedRowData.id);

      if (
        response.data &&
        response.data.results &&
        response.data.results.length > 0
      ) {
        const today = new Date();
        const responsibilityData = response.data.results;

        const transformedResponsibilities = responsibilityData.map((resp) =>
          this.transformResponsibilityDataFromAPI(
            resp,
            expandedRowData.id,
            roleAssignmentId,
            today
          )
        );

        // Add transformed responsibilities to dataSource
        this.dataSource = [...this.dataSource, ...transformedResponsibilities];

        // Update the parent role to show it has responsibilities
        const roleIndex = this.dataSource.findIndex(
          (item) => item.id === expandedRowData.id
        );
        if (roleIndex !== -1) {
          this.dataSource[roleIndex].data.hasResponsibilities = true;
          this.dataSource[roleIndex].data.responsibilityCount =
            transformedResponsibilities.length;
        }
      }
    },
    onOptionClick(item) {
      if (item?.item) {
        switch (item.item.value) {
          case "issue_badge_action":
            this.onIssueBadge(item);
            break;
          case "retire_responsibility":
            this.showRetireResponsibilityDialog = true;
            this.currentResponsibility = item.data.data;
            break;
          default:
            break;
        }
      } else {
        this.onIssueBadge(item);
      }
    },
    async retireResponsibility() {
      this.$loader.show();
      try {
        const id = this.currentResponsibility?.responsibility_id;
        const name = this.currentResponsibility?.name;

        const account_id =
          this.cachedAccountID ||
          JSON.parse(localStorage.getItem("currentAccountID"));
        if (!id || !name) {
          throw "data missing error";
        }
        const payload = {
          status: "retired",
          name: this.currentResponsibility?.name,
          account: account_id,
        };
        await updateRetireResponsibility(account_id, id, payload);
        this.showRetireResponsibilityDialog = false;
        // Immediately fetch fresh employee data from API to update status
        const employeeData = await this.employeeStore.fetchCurrentEmployee(
          this.employeeInfo?.id,
          true
        );
        if (employeeData) {
          // Update store and local data with fresh employee status
          this.$store.commit("employeeStore/setCurrentEmployee", employeeData);
          this.employeeData = employeeData;
        }

        // Use reloadDataAfterChanges instead of loadData to properly clear cache
        // and refresh tree expansion state
        await this.reloadDataAfterChanges();
      } catch (e) {
        console.log("error: ", e);
      } finally {
        this.$loader.hide();
      }
    },
    async onIssueBadge(item) {
      this.$loader.show();
      const emp_id = this.$route.params.id || this.$route.query.employeeId;

      const [response, evaluateData, badgesResponse] = await Promise.all([
        getListActiveCheckpointsEvalV2(
          this.cachedAccountID,
          item.data.data.responsibility_id,
          emp_id,
          item.data.data?.checkpointCounts?.active_checkpoints_count,
          0
        ),
        getAssignmentEval(
          this.cachedAccountID,
          item.data.data.responsibility_id,
          "responsibility"
        ),
        getEmployeeBadges(this.cachedAccountID, emp_id),
      ]);

      this.$loader.hide();

      // Assign badges data to the employee object for the modal
      if (badgesResponse?.data?.results) {
        // Get current employee data
        const currentEmployeeData =
          this.$store.getters["employeeStore/currentEmployee"];
        if (currentEmployeeData) {
          // Create a copy and add badges
          this.employeeDataWithBadges = {
            ...currentEmployeeData,
            badges: badgesResponse.data.results,
            badgeList: badgesResponse.data.results,
          };
        }
      }

      this.checkpointsData = response?.data?.results?.map((el) => {
        const newEl = {};
        newEl.id = el.checkpoint;
        newEl.checkpoint_id = el.checkpoint;
        newEl.level = el.proficiency_level;
        newEl.level_name = this.getProficiencyLevelNameFromNumber(el);
        newEl.criteria = el.checkpoint_criteria;
        newEl.instructions = el.checkpoint_instructions;
        newEl.status = el.status;
        newEl.evaluation_status = el.status;
        newEl.change_evaluation_status = this.updateChangeEvaluationStatus(el);
        newEl.failed_by = el.evaluated_by?.name || null;
        newEl.failed_on = el.evaluated_on;
        newEl.failed_reason = el.reason;
        newEl.reset_by = el.reset_by;
        newEl.reset_on = el.reset_on || "";
        newEl.reset_reason = "";
        newEl.updated_on = el.evaluated_on;
        newEl.updated_by = {
          ...el.evaluated_by,
          picture: el.evaluator_avatar,
        };
        newEl.avatar = el.evaluator_avatar;
        return newEl;
      });

      let currentEmployee = null;
      let currentEmployeeData = null;
      this.currentSelectRes = item;

      this.currentResponsibility = {
        id: item.data.data.responsibility_id,
        name: item.data?.data?.name,
        code_str: item.data?.data?.code,
        code: this.extractCode(item.data?.data?.code),
      };

      // Extract checkpoint counts from the clicked item
      this.currentCheckpointCounts = item.data?.data?.checkpointCounts || {
        apprentice_checkpoint_count: 0,
        professional_checkpoint_count: 0,
        coach_checkpoint_count: 0,
        master_checkpoint_count: 0,
        apprentice_passed_checkpoint_count: 0,
        professional_passed_checkpoint_count: 0,
        coach_passed_checkpoint_count: 0,
        master_passed_checkpoint_count: 0,
      };

      const hasActiveStatus = this.checkpointsData.length > 0;

      if (hasActiveStatus) {
        this.showEmployeeIssueBadge = false;
        this.isForceBadge = false;
        this.employeeDataWithBadges = null; // Clear badge data when using inspect modal
        this.isInspectResModal = true;

        currentEmployeeData =
          this.$store.getters["employeeStore/currentEmployee"];

        this.evalModalHeaderState = {
          responsibilityCode: evaluateData.data.responsibility.code,
          responsibilityName: evaluateData.data.responsibility.name,
          roleCode: evaluateData.data.role.code,
          roleName: evaluateData.data.role.name,
          positionCode: evaluateData.data.position.code,
          positionName: evaluateData.data.position.name,
        };

        currentEmployee = this.employeeInfo;

        if (currentEmployee) {
          this.evalModalEmpState = {
            id: currentEmployee.id,
            firstName: currentEmployeeData.first_name,
            lastName: currentEmployeeData.last_name,
            position: evaluateData.data.position.name,
            photoUrl: currentEmployeeData.avatar,
            availability: currentEmployee.availability,
            isAllocated: false,
            currentEmployeeBadge: item?.data?.data?.badge || null,
            access: currentEmployeeData.access ||
              currentEmployee.access || { is_suspended: false },
          };
        } else {
          console.error("No employee found with ID:", emp_id);
        }
      } else {
        // Set up employee data with badge information for force badge scenario
        const exlAppData = JSON.parse(localStorage.getItem("exlAppData"));
        currentEmployeeData =
          this.$store.getters["employeeStore/currentEmployee"];
        const employees = exlAppData?.employees;

        if (Array.isArray(employees)) {
          currentEmployee = employees.find((e) => e.id === emp_id);
        } else {
          console.error("Employees data is not an array.");
        }
        const badgeList = this.getBadgesFromDataSource(this.dataSource);

        if (currentEmployee) {
          this.evalModalEmpState = {
            id: currentEmployee.id,
            firstName: currentEmployeeData.first_name,
            lastName: currentEmployeeData.last_name,
            position: currentEmployee.title,
            photoUrl: currentEmployeeData.avatar,
            availability: 1,
            isAllocated: false,
            badgeList,
            currentEmployeeBadge: item?.data?.data?.badge || null,
            access: currentEmployeeData.access ||
              currentEmployee.access || { is_suspended: false },
          };
        } else {
          console.error("No employee found with ID:", emp_id);
        }

        this.showEmployeeIssueBadge = false;
        this.isInspectResModal = false;
        this.isForceBadge = true;
      }
      this.$loader.setAppLoading(false);
    },
    getProficiencyLevelNameFromNumber(el) {
      let levelName = "";
      if (el.proficiency_level === 1) {
        levelName = "Apprentice";
      } else if (el.proficiency_level === 2) {
        levelName = "Professional";
      } else if (el.proficiency_level === 3) {
        levelName = "Coach";
      } else if (el.proficiency_level === 4) {
        levelName = "Master";
      } else {
        levelName = "Unknown"; // Handle unexpected values
      }
      return levelName;
    },
    updateChangeEvaluationStatus(data) {
      if (
        data.evaluation_status == "not_applicable" ||
        data.status == "not_applicable"
      ) {
        return "Not Applicable";
      } else if (
        data.evaluation_status == "passed" ||
        data.status == "passed"
      ) {
        return "Passed";
      } else if (
        data.evaluation_status == "failed" ||
        data.status == "failed"
      ) {
        return "Failed";
      } else if (data.evaluation_status == "reset" || data.status == "reset") {
        return "Reset Pending Evaluation";
      } else {
        return "Pending Evaluation";
      }
    },
    async onClickForceBadge(item) {
      const responsibilityId = this.currentResponsibility?.id;
      this.loading.forceBadge = true;
      this.$loader.setAppLoading(true);

      try {
        const emp_id = localStorage.getItem("emp_id");
        const accountID =
          this.cachedAccountID || localStorage.getItem("currentAccountID");
        const payload = {
          employee: emp_id,
          responsibility: responsibilityId,
          level: item.radioVal,
          forced: true,
        };

        await createProficiencyBadge(accountID, payload);
        await this.clearModalStates();
        await this.reloadDataAfterBadgeOperation();
        this.$loader.setAppLoading(false);
      } catch (error) {
        console.error("Error issuing badge:", error);
        this.clearModalStates();
        this.$loader.setAppLoading(false);
      } finally {
        this.loading.forceBadge = false;
        this.$loader.setAppLoading(false);
      }
    },
    updateResponsibilityBadge(responsibilityId, badgeLevel) {
      const respIndex = this.dataSource.findIndex(
        (item) =>
          item.data &&
          item.data.type === "responsibility" &&
          item.data.code === this.currentResponsibility?.code_str
      );

      if (respIndex > -1) {
        const badgeInfo = {
          id: Date.now(),
          issued_to: localStorage.getItem("emp_id"),
          is_current: true,
          level: badgeLevel,
        };
        const updatedItem = {
          ...this.dataSource[respIndex],
          data: {
            ...this.dataSource[respIndex].data,
            badge: badgeInfo,
          },
        };
        this.$set(this.dataSource, respIndex, updatedItem);
      }
    },
    getBadgesFromDataSource(dataSource) {
      const badgeList = [];
      dataSource.forEach((item) => {
        if (
          item.data &&
          item.data.badge &&
          item.data.type === "responsibility"
        ) {
          const badge = item.data.badge;
          const newBadge = {
            id: badge.id,
            issued_to: badge.issued_to,
            is_current: badge.is_current,
            level: badge.level,
            issued_for: {
              code: item.data.code, // Include the responsibility code for badge matching
            },
          };
          badgeList.push(newBadge);
        }
      });
      return badgeList;
    },
    async handleActivateEmployee() {
      this.$loader.setAppLoading(true);
      try {
        const empId =
          this.employeeData?.id ||
          this.$route?.params?.id ||
          this.$route?.query?.employeeId;
        const accountID = JSON.parse(localStorage.getItem("currentAccountID"));
        await activateEmployee(accountID, empId);

        // Use the same pattern as EmployeeHorizontalSideBar - fetch and set employee data
        const employeeData = await this.employeeStore.fetchCurrentEmployee(
          empId,
          true
        );
        if (employeeData) {
          // Normalize status field - ensure both status and current_status are set
          const normalizedEmployeeData = {
            ...employeeData,
            status: employeeData.status || employeeData.current_status,
            current_status: employeeData.current_status || employeeData.status,
          };

          // Update both stores for backward compatibility (same as EmployeeHorizontalSideBar)
          this.$store.commit(
            "employeeStore/setCurrentEmployee",
            normalizedEmployeeData
          );

          // Update Pinia store as well
          this.employeeStore.setCurrentEmployee(normalizedEmployeeData);

          // CRITICAL: Force update employeeData using Vue.set to ensure reactivity
          this.$set(this, "employeeData", { ...normalizedEmployeeData });

          // Force Vue to recognize the change immediately
          await this.$nextTick();
          this.$forceUpdate();

          // Call handleEmployeeStatusChanged to trigger reactivity and data reload
          await this.handleEmployeeStatusChanged();
        }

        this.onCloseModal();
      } catch (e) {
        console.error("Error activating employee:", e);
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
    async reactivateEmployee() {
      try {
        this.$loader.setAppLoading(true);
        const empId =
          this.employeeData?.id ||
          this.$route?.params?.id ||
          this.$route?.query?.employeeId;
        const accountID = JSON.parse(localStorage.getItem("currentAccountID"));
        if (this.unArchiveEmployee) {
          await unArchiveEmployee(accountID, empId);
        }
        await reactivateEmployee(accountID, empId);
        // Immediately fetch fresh employee data from API to update status
        const employeeData = await this.employeeStore.fetchCurrentEmployee(
          empId,
          true
        );
        if (employeeData) {
          // Normalize status field - ensure both status and current_status are set
          const normalizedEmployeeData = {
            ...employeeData,
            status: employeeData.status || employeeData.current_status,
            current_status: employeeData.current_status || employeeData.status,
          };

          // Update both stores for backward compatibility (same as EmployeeHorizontalSideBar)
          // Use Vue.set to ensure reactivity
          this.$store.commit(
            "employeeStore/setCurrentEmployee",
            normalizedEmployeeData
          );

          // Update Pinia store as well
          this.employeeStore.setCurrentEmployee(normalizedEmployeeData);

          // CRITICAL: Force update employeeData using Vue.set to ensure reactivity
          this.$set(this, "employeeData", { ...normalizedEmployeeData });

          // Force Vue to recognize the change immediately
          await this.$nextTick();
          this.$forceUpdate();

          // Call handleEmployeeStatusChanged to trigger reactivity and data reload
          await this.handleEmployeeStatusChanged();
        }

        this.onCloseModal();
        this.$loader.setAppLoading(false);
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.log("e: ", e);
      }
    },
    async onAssignPositionToEmployee(item) {
      const accountID = JSON.parse(localStorage.getItem("currentAccountID"));
      this.loading.employeeAssignment = true;
      this.$loader.setAppLoading(true);
      // Clear any previous error messages
      this.errorMessage = "";
      if (!this.employeeData?.id || !item?.id) {
        this.$loader.setAppLoading(false);
        return;
      }
      try {
        const payload = {
          employee: this.employeeData.id,
          position: item.id,
          commitment: 1,
          allocation: 1,
          effective_on: item.effective_on,
        };
        await addPositionAssignment(accountID, payload);
        // Employee data will be updated by sidebar component after position assignment
        await this.reloadDataAfterChanges();
        // Emit employeeUpdated event to notify parent component (EmployeeDetail) to refresh
        this.$emit("employeeUpdated");
        this.$toast.success("Position assigned successfully.");
        this.onCloseModal();

        // Delayed API refresh after 2-3 seconds to ensure backend has processed the changes
        setTimeout(async () => {
          try {
            await this.reloadDataAfterChanges();
            // Also emit update event to parent
            this.$emit("employeeUpdated");
          } catch (error) {
            console.error(
              "Error in delayed position assignment refresh:",
              error
            );
          }
        }, 2500); // 2.5 seconds delay
      } catch (e) {
        console.error("error: ", e);
        // Handle API error messages
        if (e.response && e.response.status === 400 && e.response.data) {
          // Check if error response is an array (as mentioned in the user's case)
          if (Array.isArray(e.response.data) && e.response.data.length > 0) {
            this.errorMessage = e.response.data[0];
            this.$toast.error(e.response.data[0]);
          } else if (typeof e.response.data === "string") {
            this.errorMessage = e.response.data;
            this.$toast.error(e.response.data);
          } else if (e.response.data.message) {
            this.errorMessage = e.response.data.message;
            this.$toast.error(e.response.data.message);
          } else {
            this.errorMessage =
              "An error occurred while assigning the position.";
            this.$toast.error(
              "An error occurred while assigning the position."
            );
          }
        } else {
          this.errorMessage = "An error occurred while assigning the position.";
          this.$toast.error("An error occurred while assigning the position.");
        }
      } finally {
        this.$loader.setAppLoading(false);
        this.loading.employeeAssignment = false;
      }
    },
    extractCode(str) {
      let match = str?.match(/#\d+/);
      return match ? match[0] : null;
    },
    async getEmployeeData() {
      try {
        // Get employee data from store (updated by sidebar component)
        const employeeData =
          this.employeeStore.currentEmployee ||
          this.$store.getters["employeeStore/currentEmployee"];
        if (employeeData) {
          this.employeeData = employeeData;
        }
      } catch (error) {
        console.error("Error fetching employee data:", error);
        // Fallback to store data if API fails
        const data = await this.$store.getters["employeeStore/currentEmployee"];
        if (data) {
          this.employeeData = data;
        }
      }
    },
    async showRemoveBadge(item) {
      this.$refs.PathToReadinessTreeList.showRemoveBadge(item);
    },
    onEmployeeModalBack() {
      this.isForceBadge = false;
      this.employeeDataWithBadges = null; // Clear badge data when modal closes
    },

    clearModalStates() {
      // Clear all modal states to prevent unwanted reopening
      this.isInspectResModal = false;
      this.isForceBadge = false;
      this.showEmployeeIssueBadge = false;
      this.showBadgeConfirmationDialog = false;
      this.showAwardBadgeModal = false;
      this.employeeDataWithBadges = null;
      this.currentSelectRes = null;
      this.currentResponsibility = null;
      this.badgeData = null;
      this.evalModalEmpState = null;
      this.evalModalHeaderState = null;
    },

    async onImportanceChanged(event) {
      const item = this.dataSource.find((item) => item.id === event.itemId);
      if (item && item.data) {
        item.data.importanceLevel = event.newImportance;

        const empId = this.cachedEmpId || this.$route?.params?.id;
        if (empId) {
          try {
            this.$loader.show();

            const readinessData =
              await this.employeeStore.recalculateCurrentEmployeeReadiness(
                empId
              );

            if (readinessData) {
              this.$store.commit(
                "employeeStore/setCurrentEmployeeReadiness",
                readinessData.current_readiness
              );

              const employeeData =
                this.employeeStore.currentEmployee ||
                this.$store.getters["employeeStore/currentEmployee"];

              if (employeeData) {
                this.employeeData = {
                  ...employeeData,
                  current_readiness: readinessData.current_readiness,
                  needs_recalc: readinessData.needs_recalc,
                };
              }
            }

            await this.reloadDataAfterChanges();
          } catch (error) {
            console.error(
              "Error recalculating readiness on importance change:",
              error
            );
          } finally {
            this.$loader.hide();
          }
        }
      }
    },
    getBadgeLevel(level) {
      switch (level) {
        case 1:
          return "Apprentice";
        case 2:
          return "Professional";
        case 3:
          return "Coach";
        case 4:
          return "Master";
        default:
          return "Unknown";
      }
    },
    async handlePaginationRequest(paginationData) {
      // Calculate offset from page and limit
      this.pagination.page = paginationData.page;
      this.pagination.offset =
        (paginationData.page - 1) * this.pagination.limit;
      this.$loader.show();
      try {
        // Preserve current expansion state before pagination
        this.preserveExpansionState();

        const empId =
          this.cachedEmpId ||
          this.$route.params.id ||
          this.$route.query.employeeId;
        const accountID =
          this.cachedAccountID ||
          JSON.parse(localStorage.getItem("currentAccountID"));
        await this.getEmpAssignments(accountID, empId);

        // Refresh child data to show latest changes
        await this.refreshExpandedChildData(accountID, empId);

        // Force TreeList to re-render but preserve expansion state
        this.treeListKey++;

        // Restore expansion state after data is loaded
        // Use a combination of $nextTick and setTimeout for better timing
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.restoreExpansionState();
          });
        });
      } catch (error) {
        console.error("Error loading paginated data:", error);
      } finally {
        this.$loader.hide();
      }
    },

    addSkeletonLoaders(parentId, rowType, count = null) {
      // Check if skeleton loaders already exist for this parent
      const existingSkeletons = this.dataSource.filter(
        (item) =>
          item.parentId === parentId && item.data && item.data.isSkeletonLoader
      );

      if (existingSkeletons.length > 0) {
        return; // Skip adding if already exists
      }

      // Use provided count or fallback to default values
      const skeletonCount = count || (rowType === "position" ? 2 : 3);
      const skeletonItems = [];

      for (let i = 0; i < skeletonCount; i++) {
        const skeletonId = `skeleton-${parentId}-${i}`;
        skeletonItems.push({
          id: skeletonId,
          parentId: parentId,
          data: {
            type: "skeleton",
            assignmentType: rowType === "position" ? "role" : "responsibility",
            skeletonFor: rowType,
            isSkeletonLoader: true,
            commitmentLevel: "",
            importanceLevel: 0,
            importanceSelector: false,
            totalSteps: 3,
            code: "",
            name: "",
            isNew: false,
            isAccepted: false,
            acceptanceStatus: "pending",
          },
          readiness: 0,
          status: "loading",
        });
      }

      // Add skeleton items to dataSource
      this.dataSource = [...this.dataSource, ...skeletonItems];
    },

    removeSkeletonLoaders(parentId) {
      // Remove skeleton items for this parent
      this.dataSource = this.dataSource.filter((item) => {
        const isSkeletonForParent = item.id
          .toString()
          .startsWith(`skeleton-${parentId}-`);
        const isSkeletonLoader = item.data && item.data.isSkeletonLoader;
        const hasCorrectParent = item.parentId === parentId;

        // Remove if it's a skeleton loader for this parent
        return !(isSkeletonForParent && isSkeletonLoader && hasCorrectParent);
      });
    },

    // Helper method to extract original ID from prefixed ID
    getOriginalId(prefixedId) {
      if (typeof prefixedId === "string") {
        if (prefixedId.startsWith("position_"))
          return prefixedId.replace("position_", "");
        if (prefixedId.startsWith("role_"))
          return prefixedId.replace("role_", "");
        if (prefixedId.startsWith("responsibility_"))
          return prefixedId.replace("responsibility_", "");
      }
      return prefixedId;
    },

    // Expansion state management methods
    preserveExpansionState() {
      try {
        const treeListRef =
          this.$refs &&
          this.$refs.PathToReadinessTreeList &&
          this.$refs.PathToReadinessTreeList.$refs &&
          this.$refs.PathToReadinessTreeList.$refs.treelist;
        if (treeListRef && treeListRef.instance) {
          const treeInstance = treeListRef.instance;
          const currentExpandedKeys = treeInstance.getExpandedRowKeys() || [];
          this.expandedKeys = [...currentExpandedKeys];
        } else {
          console.warn("TreeList reference not found during preserve");
          // Keep existing expanded keys if available
        }
      } catch (error) {
        console.warn("Could not preserve expansion state:", error);
        // Don't reset expandedKeys here, keep what we have
      }
    },

    restoreExpansionState() {
      try {
        if (this.expandedKeys.length > 0) {
          // Force reactivity by creating a new array reference
          this.expandedKeys = [...this.expandedKeys];
        } else {
          console.log("No expansion state to restore");
        }
      } catch (error) {
        console.warn("Could not restore expansion state:", error);
      }
    },

    handleExpansionStateChange(expandedKeys) {
      // Update our local copy of expanded keys when user manually expands/collapses
      this.expandedKeys = expandedKeys || [];
    },

    async refreshExpandedChildData(accountID, empId) {
      // Get all expanded keys to know what child data to refresh
      const expandedKeys = this.expandedKeys || [];
      if (expandedKeys.length === 0) {
        return;
      }

      // Show loading state for readiness bar during refresh
      this.loading.readinessBar = true;

      try {
        // Clear the cache so we can reload fresh data
        this.loadedChildData.clear();

        // Remove all child items from dataSource so they can be reloaded with fresh data
        this.dataSource = this.dataSource.filter(
          (item) => item.parentId === -1
        );

        // Reload child data for each expanded item
        for (const expandedKey of expandedKeys) {
          const expandedItem = this.dataSource.find(
            (item) => item.id === expandedKey
          );
          if (!expandedItem) continue;

          try {
            if (expandedItem.data && expandedItem.data.type === "position") {
              // Get the numeric ID from the prefixed ID
              const positionAssignmentId = expandedKey.replace("position_", "");
              await this.handlePositionExpansion(
                accountID,
                empId,
                positionAssignmentId
              );
            } else if (expandedItem.data && expandedItem.data.type === "role") {
              // Get the numeric ID from the prefixed ID
              const roleAssignmentId = expandedKey.replace("role_", "");
              await this.handleRoleExpansion(
                accountID,
                empId,
                roleAssignmentId,
                expandedItem
              );
            }
          } catch (error) {
            console.error(`Error refreshing data for ${expandedKey}:`, error);
          }
        }
      } finally {
        this.loading.readinessBar = false;
      }
    },
  },
};
</script>
<style>
.custom-path-readiness {
  border: 1px solid #eaecf0;
  box-shadow: 0px 1px 2px 0px #1018280d;
  border-radius: 8px;
  padding: 15px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.readiness-title {
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
  color: #344054;
}

.custom-readiness {
  width: 100%;
  margin-left: 15px;
}

.custom-readiness .progress-bar-container {
  width: 100%;
}

.custom-readiness .progress-value {
  font-weight: 600;
}

.custom-path {
  border: 1px solid #eaecf0;
  box-shadow: 0px 1px 2px 0px #1018280d;
  border-radius: 8px;
  width: 100%;
  overflow: visible;
}

.path-to-readiness-scrollable {
  min-height: 0;
}

.path-to-readiness-scrollable ::v-deep .ex-pathtoread-treelist {
  min-height: 0;
}

.path-to-readiness-scrollable ::v-deep .dx-treelist {
  min-height: 0;
}

.path-to-readiness-scrollable ::v-deep .dx-scrollable-wrapper {
  min-height: 0;
}

.path-to-readiness-scrollable ::v-deep .dx-scrollable-container {
  min-height: 0;
}

/* Ensure parent containers allow scrolling */
::v-deep .employee-card-path-to-readiness {
  overflow: visible !important;
  height: auto !important;
  max-height: none !important;
}

::v-deep .employee-card-path-to-readiness .custom-path {
  overflow: visible !important;
  height: auto !important;
  max-height: none !important;
}

::v-deep .employee-card-path-to-readiness .custom-path .ex-pathtoread-treelist {
  overflow: visible !important;
  height: auto !important;
  max-height: none !important;
}

::v-deep
  .employee-card-path-to-readiness
  .custom-path
  .ex-pathtoread-treelist
  .dx-treelist {
  height: auto !important;
  max-height: none !important;
}

::v-deep
  .employee-card-path-to-readiness
  .custom-path
  .ex-pathtoread-treelist
  .dx-treelist-rowsview {
  /* Remove scrolling from table - always scroll page instead */
  overflow: visible !important;
  height: auto !important;
  max-height: none !important;
  overscroll-behavior: none;
}
</style>
<style scoped>
::v-deep(.employee-card-header-chatter-link:hover) {
  margin-top: 0;
}

/* Make the readiness bar wider like in new organization employee detail */
::v-deep
  .employee-card-path-to-readiness
  .employee-page-header
  .employee-readiness-section {
  flex: 1 1 auto;
  min-width: 400px;
  max-width: 600px;
  margin: 0 30px;
}

::v-deep
  .employee-card-path-to-readiness
  .employee-page-header
  .employee-readiness-section
  .ex-employee-readiness-box {
  width: 100%;
}
</style>
